<template>
  <div class="home" @wheel="goWheel">
    <el-carousel height="88vh" ref="swiper" direction="vertical" :autoplay="false" trigger="click" @change="change">
      <el-carousel-item>
        <HomeBanner :list="bannerList" />
      </el-carousel-item>
      <el-carousel-item>
        <HomeStory ref="HomeStory" :homelist="homelist" />
      </el-carousel-item>
      <el-carousel-item>
        <CompanyGroup :companyTotal="companyTotal" @currentChange="changeCompany" :brand_list='brand_list' />
      </el-carousel-item>
      <el-carousel-item>
        <StarShop :product_list="product_list" />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  get_configs,
  get_banner_list,
  get_homelist,
  get_brand_list,
  get_product_list
} from "@/api/api";
import HomeBanner from '@/components/home/HomeBanner.vue'
import HomeStory from '@/components/home/HomeStory.vue'
import CompanyGroup from '@/components/home/CompanyGroup.vue'
import StarShop from '@/components/home/StarShop.vue'

export default {
  name: 'HomeView',
  components: {
    HomeBanner,
    HomeStory,
    CompanyGroup,
    StarShop
  },
  data() {
    return {
      one: true,
      carouselIndex: 0,
      bannerList: [],
      configs: '',
      homelist: [],
      brand_list: [],
      product_list: [],
      postData: {
        per_page: 3,
        page: 1,
      },
      companyTotal: 0
    }
  },
  mounted() {
    this.get_configs()
    this.get_banner_list()
    this.get_homelist()
    this.get_brand_list()
    this.get_product_list()
  },

  methods: {

    get_product_list() {
      get_product_list({
        per_page: 10,
        page: 1,
        category_id: null,
        is_hot: 1
      }).then(res => {
        this.product_list = res.data
      })
    },
    get_configs() {
      get_configs().then((res) => {
        console.log(res, this.STATICURL);
        this.configs = res
        // localStorage.setItem('configs',res)
      })
    },
    get_homelist() {
      get_homelist().then(res => {
        this.homelist = res
        this.$nextTick(() => {
          this.$refs.HomeStory.changeIndex(0)

        })
      })
    },
    changeCompany(e) {
      this.postData.page = e
      this.get_brand_list()
    },
    get_brand_list() {
      get_brand_list(this.postData).then(res => {
        this.brand_list = res.data
        this.companyTotal = res.total
      })
    },
    get_banner_list() {
      get_banner_list().then((res) => {
        console.log(res);
        this.bannerList = res

      })
    },
    change(e) {
      console.log(e);
      this.carouselIndex = e

    },
    goWheel() {
      if (event.deltaY > 0 && this.one == true) { //data中定义one为true 当one为true时执行

        if (this.carouselIndex == 3) return
        this.$refs.swiper.next();           //以此来控制每次轮播图切换的张数
        this.one = false;
        setTimeout(() => {
          this.one = true
        }, 1000)
      }

      if (event.deltaY < 0 && this.one == true) {
        if (this.carouselIndex == 0) return
        this.$refs.swiper.prev();
        this.one = false;
        setTimeout(() => {
          this.one = true
        }, 1000)
      }
    },

  }

}
</script>


<style lang="less" scoped>
.home {
  padding-top: 12vh;
  box-sizing: border-box;
}




/deep/ .el-carousel__indicator--vertical button {
  width: 12px;
  height: 12px;
  background: #ffffff;
  border-radius: 50%;
  margin: 5px 0;
  border: 2px solid #8A2E26;
}
</style>
